import { EdiphiDatasourceType, useDatasources } from "../context/DatasourceContext";
import { useUserSettings } from "../context/UserSettingsContext";

/**
 * Whether the Data Tables action is on offer: a datasource to draw from, and no sheets written yet.
 *
 * Shared by the Reports section's Add button and the drawer that button opens. They previously each
 * decided for themselves, and drifted — the button counted report templates only, so a datasource with
 * no visible templates left Data Tables listed in a drawer that could not be opened.
 */
export const hasDataTableDatasource = (ediphiDatasources: EdiphiDatasourceType[]): boolean =>
  ediphiDatasources.some((type) => type !== "cost-model");

export const useCanAddDataTables = (): boolean => {
  const { ediphiDatasources } = useDatasources();
  const { settings } = useUserSettings();
  return hasDataTableDatasource(ediphiDatasources) && !settings.hasDataSheets;
};

export default useCanAddDataTables;
